module.exports = __webpack_public_path__ + "media/images/no-image-8bf95e67faafeedfeb59b7f1ebcc0c2b.png";